<div class="main-navbar">
  <div class="leftt">
    <a
      id="btn-collapse"
      href="#"
      (click)="toggleMenu($event)"
    >
      <i class="ri-menu-line ri-xl"></i>
    </a>
    <a
      id="btn-toggle"
      href="#"
      (click)="toggleMenu($event)"
      class="sidebar-toggler break-point-lg"
    >
      <i class="ri-menu-line ri-xl"></i>
    </a>
  </div>

  <div class="right-div">
    <div class="noti-pro-div">
      <button
        type="button"
        class="btn noti-icon pb-0"
        data-toggle="fullscreen"
        (click)="fullscreen()"
      >
        <i class="bx bx-fullscreen"></i>
      </button>
      <!-- <a class="notification">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_10_5716"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="2"
            y="0"
            width="16"
            height="16"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.5 0.833008H17.9141V15.2897H2.5V0.833008Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_10_5716)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.2058 2.08301C7.29334 2.08301 5.26334 4.36467 5.26334 6.41217C5.26334 8.14467 4.78251 8.94551 4.35751 9.65217C4.01668 10.2197 3.74751 10.668 3.74751 11.6422C3.88668 13.2138 4.92418 14.0397 10.2058 14.0397C15.4583 14.0397 16.5283 13.1772 16.6667 11.588C16.6642 10.668 16.395 10.2197 16.0542 9.65217C15.6292 8.94551 15.1483 8.14467 15.1483 6.41217C15.1483 4.36467 13.1183 2.08301 10.2058 2.08301ZM10.2058 15.2897C6.30918 15.2897 2.78751 15.0147 2.50001 11.6955C2.49751 10.3222 2.91668 9.62384 3.28668 9.00884C3.66084 8.38551 4.01334 7.79801 4.01334 6.41217C4.01334 3.71801 6.50168 0.833008 10.2058 0.833008C13.91 0.833008 16.3983 3.71801 16.3983 6.41217C16.3983 7.79801 16.7508 8.38551 17.125 9.00884C17.495 9.62384 17.9142 10.3222 17.9142 11.6422C17.6233 15.0147 14.1025 15.2897 10.2058 15.2897Z"
              fill="#201E29"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.1649 18.7495H10.1632C9.22903 18.7487 8.34486 18.337 7.67403 17.5895C7.44319 17.3337 7.46403 16.9379 7.72069 16.7079C7.97736 16.4762 8.37236 16.497 8.60319 16.7545C9.03486 17.2354 9.58903 17.4995 10.164 17.4995H10.1649C10.7424 17.4995 11.299 17.2354 11.7315 16.7537C11.9632 16.4979 12.3582 16.477 12.614 16.7079C12.8707 16.9387 12.8915 17.3345 12.6607 17.5904C11.9874 18.3379 11.1015 18.7495 10.1649 18.7495Z"
            fill="#201E29"
          />
          <circle cx="16" cy="3" r="3" fill="#EE6F57" />
        </svg>
      </a> -->
      <a class="profile" ngbDropdown placement="top">
        <img
          src="{{userProfile}}"
          alt=""
          id="dropdownBasic2"
          style="height: 39px; width: 42px; border-radius: 50px; "
          ngbDropdownToggle
        />
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
            <!-- <a class="dropdown-item"><i class="bx bx-user font-size-16 align-middle me-1"></i> Profile</a> -->
            <a
            class="dropdown-item"
            href="javascript: void(0);"
            (click)="ChangePassword()"
            ><i
              class="bx bx-reset font-size-16 align-middle me-1"
            ></i>
            Change password</a
          >
          
            <a
              class="dropdown-item text-danger"
              href="javascript: void(0);"
              (click)="logout()"
              ><i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
              ></i>
              Logout</a
            >

          </div>
        </div>


      </a>
    </div>
  </div>
</div>
